<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        <div class="form-field-container">
          <mat-form-field class="form-field" [floatLabel]="'auto'">
            <mat-chip-grid #keywordList>
              @for (keyword of getKeywords(); track keyword) {
                <mat-chip-row [removable]="true" (removed)="removeKeyword(keyword)">
                  {{ keyword }}
                  <span matChipRemove class="icon-remove" [inlineSVG]="'/icons/icon-close.svg'"></span>
                </mat-chip-row>
              }
              <input
                [placeholder]="'global.add_keywords' | transloco"
                [matChipInputFor]="keywordList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
                (matChipInputTokenEnd)="addKeyword($event)"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>
      </form>
    </div>
  }
</div>
